module.exports = __webpack_public_path__ + "img/roles_6.e90b5f05.png";